import { useSelector } from 'react-redux';

import Impressions from 'components/common/Deal/Target/Impressions';
import Budget from 'components/common/Deal/Target/Budget';
import Frames from 'components/common/Deal/Target/Frames';
import Sweep from 'components/common/Deal/Target/Sweep';
import ShareOfTime from 'components/common/Deal/Target/ShareOfTime';
import { useHasFeatureAccess } from 'customHooks/useHasFeatureAccess';
import { FeatureFlags } from 'components/common/types/Features.types';
import { getDealFormReadOnly } from 'store/dealManagement/selectors/getDealFormReadOnly';
import { getDealType } from 'store/dealManagement/selectors/getDealType';
import { DealType, DealStatus } from 'components/common/types/Deal.types';

const Target = () => {
  const bookingStatusCode = useSelector((state) => state.dealManagement.commonDeal.bookingStatusCode);
  const dealType = useSelector(getDealType);
  const readOnly = useSelector(getDealFormReadOnly);

  return (
    <div className="grid grid-cols-12 px-12 py-6">
      {useHasFeatureAccess(FeatureFlags.NON_GUARANTEED_EXTENDED_TARGET) ||
      dealType === DealType.GUARANTEED ||
      bookingStatusCode === DealStatus.PENDING_RESERVATION ? (
        <div className="col-span-7 pr-28 grid grid-flow-row gap-11 content-start">
          <div>
            <Impressions isDisabled={readOnly} />
            <Budget disabled={readOnly} />
          </div>
          <Frames disabled={readOnly} />
        </div>
      ) : null}
      <div className="col-span-5 grid grid-flow-row gap-11 content-start">
        <ShareOfTime isDisabled={readOnly} />
        <Sweep disabled={readOnly} />
      </div>
    </div>
  );
};

export default Target;
